import { Grid, makeStyles, createStyles, Theme } from "@material-ui/core";
import React from "react";
// import countryList from 'react-select-country-list'
import { useTranslation } from "react-i18next";
import { IAddress } from "../../../utils/AnnounceInterfaces";
import AutoCompleteSolo from "../../components/OverridingMaterial/AutoCompleteSolo";
import { PropertyTextField } from "../../Properties/components/PropertyTextField";
import { IPays, IVille } from "../../../utils/DiversInterfaces";
import i18n from "../../../i18n/config";
import { PropertyTextFieldMulitline } from "../../Properties/components/PropertyTextFieldMulitline";
import { PropertyTextFieldNum } from "../../Properties/components/PropertyTextFieldNum";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
            textAlign: "left",
        },
    })
);

export function LocalisationHotel(props: {
    values: IAddress;
    handleChange: (e: any) => void;
    onChangeMultiSelect: (v: IPays) => void;
    paysList: IPays[];
    paysSelected: IPays | null;
    villeSelected: IVille | null;
    tab: IVille[];
    country: IPays | null;
    onChangeVille: (v: IVille) => void;
}) {

    const currentLang = i18n.language;

    // For country display
    const getCountryName = (country: IPays) => 
        currentLang === 'fr' ? country.nomFR : country.nomEN;

    // For city display  
    const getCityName = (city: IVille) =>
        currentLang === 'fr' ? city.nomFR : city.nomEN;


    /*console.log('[LocalistionHotel] Received props:', {
        paysList: props.paysList,
        paysSelected: props.paysSelected,
        villeSelected: props.villeSelected,
        tab: props.tab,
        country: props.country
    }); 

    React.useEffect(() => {
        console.log('[LocalistionHotel] Country selection changed:', props.paysSelected);
        console.log('[LocalistionHotel] City selection changed:', props.villeSelected);
    }, [props.paysSelected, props.villeSelected]); */

    // Add selection validation
    const validateSelection = () => {
        if (props.paysSelected) { // Instead of .length > 0
            const isCountryValid = props.paysList.some(
                c => c._id === props.paysSelected?._id
            );
            //console.log('[Localisation] Country valid:', isCountryValid);
        }
        
        if (props.villeSelected) { // Instead of .length > 0
            const isCityValid = props.tab.some(
                c => c._id === props.villeSelected?._id
            );
            //console.log('[Localisation] City valid:', isCityValid);
        }
    }

    React.useEffect(() => {
        validateSelection();
    }, [props.paysSelected, props.villeSelected]);

    const handleCountryChange = (selectedCountry: IPays) => {
            props.onChangeMultiSelect(selectedCountry);
            props.handleChange({
                target: {
                    name: "country",
                    value: selectedCountry,
                },
            });
        };      
          
    
    // Handle City Selection
    const handleCityChange = (selectedCity: IVille) => {        
        //console.log("City selected:", selectedCity);
        props.onChangeVille(selectedCity);
        props.handleChange({
            target: {
                name: "city",
                value: selectedCity,
            },
        });
    };


    const classes = styles();
    // const options = useMemo(() => countryList().getData(), []);
    const { t } = useTranslation<'common'>();
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])

    return (
        <Grid container>
            <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor="propertyCountry"
                    className={classes.inputLabel}
                    style={{ display: "block" }}
                >
                    {t("propriete.labels.pays")} *:
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inputText}>
            <AutoCompleteSolo
                id="propertyCountry"
                name="country"
                selectedValues={props.paysSelected}
                values={props.paysList || []}
                //onChangeSelect={handleCountryChange}
                onChangeSelect={(selectedCountry) => {
                    //console.log("Country changed in AutoComplete:", selectedCountry);
                    handleCountryChange(selectedCountry);
                }}
            />
            </Grid>
            <Grid item lg={12} sm={12} xs={12}>
                <label
                    htmlFor="propertyCity"
                    className={classes.inputLabel}
                    style={{ display: "block" }}
                >
                    {t("propriete.labels.nomDeLaVille")} *:
                </label>
            </Grid>
            <Grid item lg={12} sm={12} xs={12} className={classes.inputText}>            
            <AutoCompleteSolo
                id="propertyCity"
                name="city"
                selectedValues={props.villeSelected}
                values={props.tab || []}
                //onChangeSelect={handleCityChange}
                onChangeSelect={(selectedCity) => {
                    //console.log("City changed in AutoComplete:", selectedCity);
                    handleCityChange(selectedCity);
                }}
            />
            </Grid>
            <PropertyTextField
                id="propertyStreet"
                label={`${t("propriete.labels.quartier")} *:`}
                name="quartier"
                value={props.values.quartier}
                handleChange={props.handleChange}
            />
            <PropertyTextField
                id="propertyStreet"
                label={`${t("propriete.labels.nomDeRue")} :`}
                name="street"
                value={props.values.street}
                handleChange={props.handleChange}
            />
            <PropertyTextField
                id="propertyStreet"
                label={`${t("propriete.labels.lieu-dit")} :`}
                name="lieu_dit"
                value={props.values.lieu_dit}
                handleChange={props.handleChange}
            />
            <PropertyTextField
                id="propertyZipCode"
                label={`${t("propriete.labels.codePostal")} :`}
                name="zipcode"
                value={props.values.zipcode}
                handleChange={props.handleChange}
            />
            <PropertyTextField
                id="properState"
                label={`${t("propriete.labels.etatOuProvince")} :`}
                name="state"
                value={props.values.state}
                handleChange={props.handleChange}
            />
            <Grid
                container
                spacing={1}
                style={{ textAlign: "left" }}
                direction="row"
                alignItems="center"
            >
                <Grid item xs={6} sm={3}>
                    <label htmlFor="hotelContactName" className={classes.inputLabel}>
                        {t("annonce.labels.nom-du-contact")}
                    </label>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <PropertyTextField
                        id="hotelContactName"
                        label=""
                        name="hotelContactName"
                        value={props.values.hotelContactName || ""}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <label
                        htmlFor="hotelContactPhone"
                        className={classes.inputLabel}
                    >
                        {t("annonce.labels.numero-du-contact")}
                    </label>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <PropertyTextFieldNum
                        id="hotelContactPhone"
                        codenum={props.values.hotelCodePhone || ""}
                        label=""
                        name="hotelContactPhone"
                        value={props.values.hotelContactPhone || ""}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={12}>
                    <PropertyTextFieldMulitline
                        id="hotelHowToAccessDesc"
                        label=""
                        name="hotelHowToAccessDesc"
                        value={props.values.hotelHowToAccessDesc || ""}
                        minRows={5}
                        handleChange={props.handleChange}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label htmlFor="sponsorshipCode">
                    {`${t('propriete.labels.localisationGPS')} :`}
                    </label>
                </Grid>
                <Grid item xs={8}>
                    <PropertyTextField
                        id="hotelGPSLink"
                        label=""
                        name="hotelGPSLink"
                        value={props.values.hotelGPSLink || ""}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
